export default "__VITE_ASSET__BvGIBVFu__"